import React from 'react';
import { IconProps } from './types';

const AgentPerformanceIcon: React.FC<IconProps> = props => {
  const {
    size = 68,
    fillColor = 'var(--navi-color-blue-dark)',
    fillColor1 = '#E0EFFF',
    className
  } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12805_153585)">
        <rect x="4" y="2" width="60" height="60" rx="8" fill={fillColor1} />
      </g>
      <mask id="mask0_12805_153585" maskUnits="userSpaceOnUse" x="14" y="12" width="40" height="40">
        <rect x="14" y="12" width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12805_153585)">
        <path
          d="M19.5 48.2183C19.2239 48.2183 19 47.9944 19 47.7183V44.7582C19 44.6336 19.0466 44.5134 19.1306 44.4213L21.4639 41.8635C21.7717 41.5262 22.3333 41.7439 22.3333 42.2005V47.7183C22.3333 47.9944 22.1095 48.2183 21.8333 48.2183H19.5ZM26.1667 48.2183C25.8905 48.2183 25.6667 47.9944 25.6667 47.7183V37.4505C25.6667 37.3258 25.7133 37.2056 25.7973 37.1135L28.1306 34.5558C28.4383 34.2185 29 34.4362 29 34.8928V47.7183C29 47.9944 28.7761 48.2183 28.5 48.2183H26.1667ZM32.8333 48.2183C32.5572 48.2183 32.3333 47.9944 32.3333 47.7183V34.9047C32.3333 34.4466 32.8981 34.2297 33.2048 34.57L35.5381 37.1597C35.6209 37.2515 35.6667 37.3708 35.6667 37.4944V47.7183C35.6667 47.9944 35.4428 48.2183 35.1667 48.2183H32.8333ZM39.5 48.2183C39.2239 48.2183 39 47.9944 39 47.7183V37.4962C39 37.3715 39.0466 37.2513 39.1306 37.1592L41.4639 34.6015C41.7717 34.2642 42.3333 34.4819 42.3333 34.9385V47.7183C42.3333 47.9944 42.1095 48.2183 41.8333 48.2183H39.5ZM46.1667 48.2183C45.8905 48.2183 45.6667 47.9944 45.6667 47.7183V30.1428C45.6667 30.0181 45.7133 29.8979 45.7973 29.8058L48.1306 27.2481C48.4383 26.9108 49 27.1285 49 27.5851V47.7183C49 47.9944 48.7761 48.2183 48.5 48.2183H46.1667ZM19.8694 37.8109C19.5617 38.1482 19 37.9305 19 37.474V33.7966C19 33.672 19.0466 33.5518 19.1306 33.4597L30.2973 21.2192C30.4956 21.0018 30.8378 21.0018 31.036 21.2192L36.9639 27.7171C37.1622 27.9345 37.5044 27.9345 37.7027 27.7171L48.1306 16.2865C48.4383 15.9492 49 16.1669 49 16.6235V20.3008C49 20.4255 48.9534 20.5456 48.8694 20.6378L37.7027 32.8782C37.5044 33.0956 37.1622 33.0956 36.9639 32.8782L31.036 26.3803C30.8378 26.1629 30.4956 26.1629 30.2973 26.3803L19.8694 37.8109Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_12805_153585"
          x="0"
          y="0"
          width={size}
          height={size}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12805_153585"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12805_153585"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AgentPerformanceIcon;
